var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useApiInstance } from '@/api';
import { useAuth } from '@/context/AuthContext';
const AuthGate = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [showRegister, setShowRegister] = useState(false);
    const { user, loading, login, logout } = useAuth();
    const [form, setForm] = useState({ username: '', email: '', password1: '', password2: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { t } = useTranslation();
    const api = useApiInstance();
    const apiRegister = api.authApiInstance.register;
    useEffect(() => {
        if (user) {
            console.log('User is authenticated:', user);
            navigate('/initiative-tracker', { replace: true });
        }
        else {
            console.log('User is not authenticated');
        }
    }, [user, navigate]);
    console.log('AuthGate user:', user);
    console.log('loading:', loading);
    if (loading)
        return _jsxs("div", { children: [t('states.loading'), "..."] });
    const handleChange = (e) => {
        setForm(Object.assign(Object.assign({}, form), { [e.target.name]: e.target.value }));
    };
    const handleLogin = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setError('');
        try {
            const { username, password1 } = form;
            yield login(username, password1);
            setIsAuthenticated(true);
            navigate('/initiative-tracker', { replace: true });
        }
        catch (e) {
            // TODO: handle different error cases
            if (typeof e === 'object' && e !== null && 'status' in e) {
                const status = e.status;
                if (status === 400) {
                    setError(t('auth.invalid_credentials'));
                }
                else if (status === 401) {
                    setError(t('auth.unauthorized'));
                }
                else if (status === 403) {
                    setError(t('auth.forbidden'));
                }
                else if (status === 404) {
                    setError(t('auth.not_found'));
                }
                else if (status === 500) {
                    setError(t('auth.server_error'));
                }
            }
        }
    });
    const handleRegister = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setError('');
        try {
            const res = yield apiRegister({
                username: form.username,
                email: form.email || '',
                password1: form.password1,
                password2: form.password2,
            });
            if (res && res.key) {
                yield login(form.username, form.password1);
                setIsAuthenticated(true);
                navigate('/initiative-tracker', { replace: true });
            }
            else {
                setError(t('errors.error'));
            }
        }
        catch (_a) {
            setError(t('errors.error'));
        }
    });
    return (_jsxs("div", { style: { maxWidth: 400, margin: '0 auto', padding: 20 }, children: [_jsxs("form", { onSubmit: showRegister ? handleRegister : handleLogin, children: [_jsx("h2", { children: showRegister ? t('auth.register') : t('auth.login') }), _jsx("input", { type: "text", name: "username", placeholder: t('auth.username'), value: form.username, onChange: handleChange, required: true }), showRegister && (_jsx("input", { type: "email", name: "email", placeholder: t('auth.email'), value: form.email, onChange: handleChange, required: true })), _jsx("input", { type: "password", name: "password1", placeholder: t('auth.password1'), value: form.password1, onChange: handleChange, required: true, autoComplete: "off" }), showRegister && (_jsx("input", { type: "password", name: "password2", placeholder: t('auth.password2'), value: form.password2, onChange: handleChange, required: true, autoComplete: "off" })), _jsx("button", { type: "submit", disabled: loading, children: showRegister ? t('auth.doRegister') : t('auth.login') }), error && _jsx("div", { style: { color: 'red' }, children: error })] }), _jsx("button", { onClick: () => setShowRegister((r) => !r), style: { marginTop: 10 }, children: showRegister ? t('auth.have_account') : t('auth.no_account') })] }));
};
export default AuthGate;
